import React, { useState, useEffect, useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Card,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@material-ui/core";
import {
  getPackage,
  updateBooking,
  getBookingById,
  getCoupons,
  getAvailableSlots,
  getCities,
  getSubCenterInfo,
  getPinCode,
  getImagingTimeslots,
  // getMultiplePackage,
  getDisplayCities,
  getMapMyIndiaAccessToken,
  checkGeoFenceArea,
  checkGeoFenchMapMyIndia,
  getDoctorInfoById,
  getCenterInfo,
  getPhlebos,
  getRefDoctor,
} from "../../../actions/GenomicsPhaAction";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Button from "@material-ui/core/Button";
import "./index.sass";
import { connect } from "react-redux";
import moment from "moment";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useHistory } from "react-router";
import { GENDER_CHOICE } from "../../constant";
import { GoogleMapsAPI } from "../../../../helpers/client-config";
import Geocode from "react-geocode";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
Geocode.setApiKey("AIzaSyBPjDlsHYhWtjt3FxgRPnTMXN-qJZ9hz0s");
Geocode.enableDebug();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 10px 10px",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      padding: "20px 20px 20px 20px",
      marginTop: "20px",
      width: "100%",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    packageLink: {
      color: "#ffffff",
      textDecoration: "none",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
  })
);

interface Props {
  getPackage: any;
  packageList: any;
  couponList: any;
  getCoupons: any;
  updateBooking: any;
  match: any;
  booking: any;
  getBookingById: any;
  booking_slots: any;
  getAvailableSlots: any;
  loading: boolean;
  getCities: any;
  cities: any;
  getSubCenterInfo: any;
  subCenter: any;
  getPinCode: any;
  getImagingTimeslots: any;
  pin_code: any;
  imagingTimeSlots: any;
  // getMultiplePackage: any;
  // multiplePackage: any;
  getDisplayCities: any;
  displayCities: any;
  checkGeoFenceArea: any;
  checkGeoFenceStatus: boolean;
  checkGeoFenchMapMyIndia: any;
  geoFencesMapMyIndia: any;
  getMapMyIndiaAccessToken: any;
  mapmyindiaAccessToken: any;
  getDoctorInfoById: any;
  doctorInfo: any;
  getCenterInfo: any;
  centerInfo: any;
  getPhlebos: any;
  phleboList: any;
  getRefDoctor: any;
  refDoctor: any;
}

const EditBookingForm: React.FC<Props> = ({
  packageList,
  getPackage,
  couponList,
  getCoupons,
  updateBooking,
  match,
  booking,
  getBookingById,
  booking_slots,
  getAvailableSlots,
  getCities,
  cities,
  subCenter,
  phleboList,
  loading,
  getPhlebos,
  getSubCenterInfo,
  getPinCode,
  getImagingTimeslots,
  imagingTimeSlots,
  // getMultiplePackage,
  // multiplePackage,
  getDisplayCities,
  displayCities,
  checkGeoFenceArea,
  checkGeoFenceStatus,
  checkGeoFenchMapMyIndia,
  geoFencesMapMyIndia,
  getMapMyIndiaAccessToken,
  mapmyindiaAccessToken,
  pin_code,
  getDoctorInfoById,
  doctorInfo,
  getCenterInfo,
  centerInfo,
  getRefDoctor,
  refDoctor,
}) => {
  const RM_COMMENTS: any = [
    {
      id: 1,
      name: "Customer not intersted"
    },
    {
      id: 2,
      name: "Customer will call back"
    },
    {
      id: 3,
      name: "Call not picked"
    },
    {
      id: 4,
      name: "Wrong Number"
    },
    {
      id: 5,
      name: "Out of service area"
    },
    {
      id: 6,
      name: "Customer irritated"
    },
    {
      id: 7,
      name: "Out of Station"
    },
    {
      id: 8,
      name: "Patient Hospitalise"
    },
    {
      id: 9,
      name: "Urgent report "
    },
    {
      id: 10,
      name: "Dupliate booking"
    },
    {
      id: 11,
      name: "Wrong Address"
    },
    {
      id: 12,
      name: "Sample already collected"
    }
  ]
  const RCA_COMMENT: any = [
    {
      id: 1,
      name: "Customer not intersted"
    },
    {
      id: 2,
      name: "Customer will call back"
    },
    {
      id: 3,
      name: "Call not picked"
    },
    {
      id: 4,
      name: "Wrong Number"
    },
    {
      id: 5,
      name: "Out of service area"
    },
    {
      id: 6,
      name: "Customer irritated"
    },
    {
      id: 7,
      name: "Out of Station"
    },
    {
      id: 8,
      name: "Patient Hospitalise"
    },
    {
      id: 9,
      name: "Urgent report "
    },
    {
      id: 10,
      name: "Dupliate booking"
    },
    {
      id: 11,
      name: "Wrong Address"
    },
    {
      id: 12,
      name: "Sample already collected"
    },
    {
      id: 13,
      name: "Phlebo delay"
    },
    {
      id: 14,
      name: "Wrong booking allocated"
    },
    {
      id: 15,
      name: "Rescheduled"
    },
    {
      id: 16,
      name: "Done from Other Lab"
    },
    {
      id: 18,
      name: "No Busy"
    }
  ]
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [collection_date, setCollection_date] = useState<String>(
    booking.collection_date
  );
  const [bookPackages, setBookPackages] = useState<any>(
    booking.packages
  );
  const [payment_mode, setPaymentMode] = useState<String>("none")

  const [centre, setCentre] = useState<String>("");
  const [addressLine2, setAddressLine2] = useState<string>(booking?.address_line2 &&
    booking?.address_line2);

  const [booking_date, setBooking_date] = useState<string>(
    booking.booking_date
  );
  const [phlebo_convenience, setPhlebo_convenience] = useState(booking?.phlebo_convenience)
  const [phlebo_verification_remark, setPhlebo_verification_remark] = useState<string>(booking?.phlebo_verification_remark)


  const [selectedSlot, setSelectedSlot] = useState<Number>(
    booking.collection_slot && booking.collection_slot.id
  );
  const [phlebo, setPhlebo] = useState<Number>();
  const [displayPhlebo, setDisplayPhlebo] = useState<any>("");

  const [pickup_amount, setPickup_amount] = useState(0);
  const [phleboName, setPhleboName] = useState<any>("")
  const [referringDoctorName, setReferringDoctorName] = useState<any>("");
  const [referringDoctor, setReferringDoctor] = useState<any>("");

  const [customer_name, setCustomer_name] = useState<String>(
    booking.customer_name
  );
  const [verification_status, setVerification_status] = useState<string>(booking?.verification_status)

  const [customer_designation, setCustomer_designation] = useState<string>();
  const [designation, setDesignation] = useState<String>();

  const [customer_age, setCustomer_age] = useState<String>(
    booking.customer_age
  );
  const checkAdditionalPickupStatus = booking?.additional_members && booking?.additional_members?.find((data: any) =>
    data.pickup_status === "pending"
  )
  const [rca_comment, setRCAComment] = useState<any>()
  const [customer_gender, setCustomer_gender] = useState<any>();
  const [customer_phonenumber, setCustomer_phonenumber] = useState<String>(
    booking.customer_phonenumber
  );
  const [pickup_status, setPickup_status] = useState(booking?.pickup_status)
  const [customer_alternatenumber, setCustomer_alternatenumber] =
    useState<String>(booking.customer_altphonenumber);
  const [customer_whatsapppnumber, setCustomer_whatsapppnumber] =
    useState<String>(booking.customer_whatsapppnumber);
  const [customer_email, setCustomer_email] = useState<String>(
    booking.customer_email
  );
  const [phlebo_incentive, setPhlebo_incentive] = useState(booking?.phlebo_incentive)
  const [remarks, setRemarks] = useState<string>(booking?.remarks)
  const [pickup_date, setPickup_date] = useState(booking?.pickup_date)


  const [favoritePlace, setFavoritePlace] = useState<any>(booking?.landmark &&
    booking?.landmark);

  const [customer_longitude, setCustomerLongitude] = useState<any>(
    booking?.customer_longitude
  );
  const [booking_status, setBooking_status] = useState<string>(booking?.booking_status)

  const [customer_latitude, setCustomerLatitude] = useState<any>(
    booking?.customer_latitude
  );
  const [pickup_time, setPickup_time] = useState(booking?.pickup_time)
  const [testType, setTestType] = useState<any>("");

  const [doctor_email, setDoctor_email] = useState<String>("");
  const [doctor_mobilenumber, setDoctor_mobilenumber] = useState<String>("");
  const [center_longitude, setCenterLongitude] = useState<any>("");
  const [center_latitude, setCenterLatitude] = useState<any>("");
  const [customer_areapincode, setCustomer_areapincode] = useState<Number>(
    booking?.customer_areapincode?.id
  );
  const [customer_address, setCustomer_address] = useState<String>(
    booking.customer_address && booking.customer_address
  );
  const [customer_city, setCustomer_city] = useState<String>("");
  const [customer_aadhar, setCustomer_aadhar] = useState<String>(
    booking.customer_aadhar
  );
  const [passport_number, setPassportNumber] = useState<String>(
    booking.passport_number
  );
  const [adharPassport, setAdharPassport] = useState(
    booking.customer_aadhar !== "" ? "customer_aadhar" : "passport_number"
  );
  const [landmark, setLandmark] = useState<any>(null);

  // const [packageDetails, setPackageDetails] = useState<any>(booking.packages);
  const [cityDisplayName, setCityDisplayname] = useState<any>(
    booking.display_name
  );
  const [packageKey, setPackageKey] = useState<any>(0);
  const [redDisc, setRedDisc] = useState<any>(0);
  // const [doctorId, setDoctorId] = useState<any>("");
  const [coupon, setCoupon] = useState<Number>(0);
  const [verification_remark, setVerification_remark] = useState<string>(booking?.verification_remark)
  const [homechecked, setHomeChecked] = useState<boolean>(false);
  const [couponCode, setCouponCode] = useState<string>("");
  const [price, setPrice] = useState<any>(
    booking.discounted_price && booking.discounted_price.total_price_package
  );
  const [discount, setDiscount] = useState<any>(
    booking.discounted_price && booking.discounted_price.counpon_discount
  );
  const [totalPrice, setTotalPrice] = useState<any>(
    booking.discounted_price && booking.discounted_price.final_total_price
  );
  const [extraCharge, setExtraCharge] = useState<boolean>(
    booking.discounted_price && booking.discounted_price.phlebo_cost !== 0
  );
  const [cityName, setCityName] = useState<any>("");
  const [cityId, setCityId] = useState<any>(booking && booking.cityid);
  const [centerName, setCenterName] = useState<String>(booking.center.name);
  const [centerId, setCenterId] = useState<any>(booking?.center.id);
  const [centerKey, setCenterKey] = useState<any>(0);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [mobileValidation, setMobileValidation] = useState({
    customer_alternatenumber: true,
    customer_phonenumber: true,
    customer_whatsapppnumber: true,
  });

  const bookingId = match.params.id;
  const [subCenterId, setSubCenterId] = useState<any>(
    booking?.center?.id
  );
  const [customer_landmark, setCustomer_landmark] = useState<String>(
    booking.customer_landmark || ""
  );
  const [sampleType, setSampleType] = useState<any>([]);

  const [subCenterDetails, setSubCenterDetails] = useState(
    booking.center_address
  );
  const [allPackage, setAllPackaage] = useState<boolean>(false);
  const [rm_comment, setRMComment] = useState<any>()
  const [centrePackages, setCentrePackages] = useState<any>([]);
  const [imgTimeSlots, setImgTimeSlots] = useState<any>([]);
  const [subCenterData, setSubCenterData] = useState<any>([]);
  const [centerMessage, setCenterMessage] = useState<string>("");
  const [singlePackage, setSinglePackage] = useState<any>({});
  const [couponMessage, setCouponMessage] = useState<string>("");
  const [tncMessage, setTncMessage] = useState<string>("");
  const [redCashCheck, setRedCashCheck] = useState<boolean>(false);
  const [isPaneOpen, setPaneOpen] = useState<boolean>(false);
  const [suggestedAddress, setSuggestedAddres] = useState<any>([]);
  const [mapAddressObject, setMapAddressObject] = useState<any>({});
  const [accessToken, setAccessToken] = useState<any>("");
  const [doctorId, setDoctorId] = useState<any>("");
  const [displayDoctorName, setDisplayDoctorName] = useState<any>("");
  const [centreNameId, setCentreNameId] = useState<number>();
  const [packageDetails, setPackageDetails] = useState<any>([]);
  const [packages, setPackages] = useState<any>([]);

  const timer = useRef<any>(0);
  useEffect(() => {
    if (bookPackages) {
      handlePackages(bookPackages)
    }
  }, [bookPackages])

  useEffect(() => {
    if (packageDetails) {
      console.log("run1")
      // do Nothing
      let packageIds: any = [];
      packageDetails &&
        packageDetails?.map((list: any) => {
          packageIds.push(list.id);
        });
      setPackages(packageIds);
    }
  }, [packageDetails]);

  useEffect(() => {
    if (booking?.coupon_applied) {
      setCoupon(booking?.coupon_applied.id);
      setCouponCode(booking?.coupon_applied?.name);
    }
    if (booking?.designation && booking?.customer_gender) {
      setCustomer_designation(booking?.designation);
      const findGender = GENDER_CHOICE.filter(
        (el: any) => el.db_name === booking?.designation
      );
      if (
        booking?.designation === "Master" &&
        booking?.customer_gender === "male"
      ) {
        setDesignation("Baby Boy");
      } else if (
        booking?.designation === "Master" &&
        booking?.customer_gender === "female"
      ) {
        setDesignation("Baby Girl");
      } else {
        findGender.length > 0 && setDesignation(findGender[0].display_name);
      }
      setCustomer_gender(booking?.customer_gender);
    }
    setCityName(booking?.display_name);
    getDisplayCities();
  }, []);

  useEffect(() => {
    // getCoupons("?org_type=imaging");
    getCities("", "?is_imaging=true");
    getMapMyIndiaAccessToken();
  }, []);
  useEffect(() => {
    if (subCenterId !== "") {
      getImagingTimeslots(
        `?packages=${packages}&collection_date=${collection_date}&center_address=${subCenterId}`
      );
    }
  }, [subCenterId]);
  useEffect(() => {
    if (subCenterId !== "") {
      setImgTimeSlots(imagingTimeSlots);
    }
  });
  useEffect(() => {
    if (booking.center) {
      setCenterId(booking.center.id)
      setCenterName(booking.center.name)

    }
    // setHomeChecked(booking?.homecollection)


  }, [booking]);

  useEffect(() => {
    if (booking.center) {
      setCenterId(booking.center.id);
      setCenterName(booking.center.name);
      setSampleType(booking.pre_post_natal);
      // setDisplayDoctorName(booking.geno_ref_doctor.username);
      // setDoctorId(booking.geno_ref_doctor.id);
      setReferringDoctorName(booking?.geno_ref_doctor && booking?.geno_ref_doctor?.username? booking?.geno_ref_doctor?.username: "" );
      setDoctor_mobilenumber(booking?.geno_ref_doctor?.phonenumber);
      setDoctor_email(booking?.geno_ref_doctor?.email);
      setCentreNameId(booking?.center?.id)
      setPhlebo(booking?.phlebo?.id);
      setDisplayPhlebo(booking?.phlebo?.name);
    }
  }, [booking]);

  const hanbdlePaymentMode = (e: any) => {
    if (e.target.value === "cash") {
      setPickup_amount(booking.receivable_amount)
      setPaymentMode(e.target.value as string)
    }
    else {
      setPickup_amount(0)
      setPaymentMode(e.target.value as string)
    }
  }
  useEffect(() => {
    if (pickup_status === "confirmed" && booking?.receivable_amount !== 0) {
      setPickup_amount(booking?.receivable_amount)
    }
    else if (pickup_status === "confirmed" && booking?.receivable_amount === 0) {
      setPaymentMode(booking?.payment_mode)
    }
    else {
      setPickup_amount(0)
      setPaymentMode("none")
    }
  }, [pickup_status])

  useEffect(() => {
    if (centerId) {
      getCenterInfo(`?genomics=true&centre_id=${centerId}`)

    }

  }, [centerId]);

  useEffect(() => {
    if (centerInfo && centerInfo.results && centerInfo.results.length > 0) {
      setCentrePackages(centerInfo.results[0].packages)
      console.log("2")

    }
  }, [centerInfo]);
  // const [openDocModal, setOpenDocModal] = useState<any>(false);
  // const handleAddDoctor = () => {
  //   setOpenDocModal(true);
  // };
  // useEffect(() => {
  //   if (allPackage) {
  //     getPackage(`org_type=org_type=genomics`);
  //   } else {
  //     getPackage(`center_address=${subCenterId}&org_type=genomics`);
  //   }
  // }, [allPackage]);

  // useEffect(() => {
  //   getSubCenterInfo(
  //     `?imaging=true&customer_latitude=${customer_latitude}&customer_longitude=${customer_longitude}&package=${packages}&display_name=${cityName}`
  //   );
  // }, []);
  // useEffect(() => {
  //   getSubCenterInfo(
  //     `?imaging=true&customer_latitude=${customer_latitude}&customer_longitude=${customer_longitude}&package=${packages}&display_name=${cityName}`
  //   );
  // }, [packages]);

  useEffect(() => {
    getBookingById(`${bookingId}`);
  }, [bookingId]);
  useEffect(() => {
    getPhlebos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handlePackages = (pack: any) => {
    setPackageDetails(pack);
    let accumulatedPrice: any = 0;
    let packIds: any = [];
    pack &&
      pack.length > 0 &&
      pack.map((item: any) => {
        packIds.push(item.id);
        setPackages(packIds);
      });
    packageDetails &&
      packageDetails.length > 0 &&
      packageDetails.map((item: any) => {
        if (item.price) {
          accumulatedPrice = accumulatedPrice + item.price;
        } else if (item.package_lab_prices) {
          accumulatedPrice = accumulatedPrice + item.package_lab_prices;
        }
      });
    // multiplePackage && multiplePackage.results && multiplePackage.results.length > 0 && multiplePackage.results.map((item: any) => {
    //     if (item.package_center_address_prices === null) {
    //         accumulatedPrice = accumulatedPrice + item.offer_price
    //     }
    //     else {
    //         accumulatedPrice = accumulatedPrice + item.package_center_address_prices.offer_price
    //     }

    //     if (accumulatedPrice < min_phlebo_cost) {
    //         setExtraCharge(false)
    //     } else {
    //         setExtraCharge(false)
    //     }
    // }
    // )
    // setPrice(Math.floor(accumulatedPrice))
    // setDiscount(0)
    // setTotalPrice(Math.floor(accumulatedPrice))
    // setCoupon(0)
    // setCouponCode("")
  };
  useEffect(() => {
    let accumulatedPrice: any = 0;
    packageDetails &&
      packageDetails.length > 0 &&
      packageDetails.map((item: any) => {
        if (item.price) {
          accumulatedPrice = accumulatedPrice + item.price;
        } else if (item.package_lab_prices) {
          accumulatedPrice = accumulatedPrice + item.package_lab_prices;
        }
      });
    setPrice(Math.floor(accumulatedPrice));
    setDiscount(0);
    setTotalPrice(Math.floor(accumulatedPrice));
    setCoupon(0);
    setCouponCode("");
  }, [packageDetails]);

  useEffect(() => {
    if (extraCharge) {
      setTotalPrice(Math.floor(price - discount + 200));
    } else {
      setTotalPrice(Math.floor(price - discount));
    }
  }, [price, discount, extraCharge]);

  useEffect(() => {
    if (totalPrice < 0) {
      setTotalPrice(0);
    }
  }, [totalPrice]);
  //   const handlePackage = (customerPackages: any) => {

  //     setPackageDetails(customerPackages);

  //    let accumulatedPrice: any = 0;
  //    if (customerPackages && customerPackages.length > 0) {
  //      customerPackages.map((item: any) => {
  //        if (item?.package_lab_prices !== null) {
  //          accumulatedPrice = accumulatedPrice + item.package_lab_prices;
  //        }
  //      });
  //    }
  //    // set price and package for row
  //    setTotalPrice(accumulatedPrice);



  //    setPrice(Math.floor(accumulatedPrice));

  //  };



  const applyCoupon = () => {
    if (couponCode === "") {
      setCouponCode("");
      setCoupon(0);
      setDiscount(0);
      return;
    }
    const appliedCoupon =
      couponList.results.find((coup: any) => coup.id === coupon) ||
      couponList.results.find((coup: any) => coup.code === couponCode);
    if (appliedCoupon && appliedCoupon.minimum_price < totalPrice) {
      setCoupon(appliedCoupon.id);
      if (appliedCoupon.discount_type.toLowerCase() === "percentage") {
        if (appliedCoupon.is_red_cash) {
          setDiscount(Math.floor(price));
        } else {
          setDiscount(Math.floor((price * appliedCoupon.discount) / 100));
        }
      }
      if (appliedCoupon.discount_type.toLowerCase() === "amount") {
        if (appliedCoupon.is_red_cash) {
          setDiscount(0);
        } else {
          setDiscount(Math.floor(appliedCoupon.discount));
        }
      }
    } else {
      setCouponCode("");
      setCoupon(0);
      setDiscount(0);
    }
  };
  const verifyMobile = (type: any) => {
    if (type === "mobile") {
      if (parseInt(customer_phonenumber && customer_phonenumber[0]) < 6 || customer_phonenumber && customer_phonenumber.length < 10) {
        setMobileValidation((prev: any) => ({
          ...prev,
          customer_phonenumber: false,
        }));
      }
    }
    if (type === "alternate") {
      if (parseInt(customer_alternatenumber && customer_alternatenumber[0]) < 6 || customer_alternatenumber && customer_alternatenumber.length < 10) {
        setMobileValidation((prev: any) => ({
          ...prev,
          customer_alternatenumber: false,
        }));
      }
    }
    if (type === "whatsapp") {
      if (parseInt(customer_whatsapppnumber && customer_whatsapppnumber[0]) < 6 || customer_whatsapppnumber && customer_whatsapppnumber.length < 10) {
        setMobileValidation((prev: any) => ({
          ...prev,
          customer_whatsapppnumber: false,
        }));
      }
    }
  };
  const submitForm = async (e: any) => {
    e.preventDefault();
    const data: any = {
      booking_date: moment(new Date()).format("YYYY-MM-DD"),
      collection_date: collection_date,
      collection_slot: selectedSlot,
      customer_name: customer_name,
      customer_age: customer_age,
      customer_gender: customer_gender,
      customer_email: customer_email,
      customer_phonenumber: customer_phonenumber,
      customer_altphonenumber: customer_alternatenumber,
      customer_whatsapppnumber: customer_whatsapppnumber,
      customer_address: customer_landmark,
      customer_landmark: customer_landmark,
      customer_longitude: customer_longitude,
      customer_latitude: customer_latitude,
      customer_areapincode: customer_areapincode,
      customer_aadhar: customer_aadhar,
      passport_number: passport_number === null ? "" : passport_number,
      packages: packages,
      coupon_applied: coupon,
      designation: customer_designation,
      // center: centerId,
      display_name: cityName,
      // center_address: subCenterId,
      // ref_doctor: doctorId,
      ref_doctor: referringDoctor,
      center: centreNameId,
      test_type: sampleType,
      homecollection: true,
      "address_line2": addressLine2,
      favoritePlace: " landmark",
      "verification_remark": verification_remark,
      "remarks": remarks,
      "rca_comment": rca_comment,
      "verification_status": verification_status,
      "booking_status": booking_status,
      "rm_comment": rm_comment,
      "pickup_status": pickup_status,
      "phlebo_incentive": phlebo_incentive,
      "phlebo_convenience": phlebo_convenience,
      "phlebo_verification_remark": phlebo_verification_remark,
      "pickup_receive_amount": pickup_amount,
      payment_mode: payment_mode,
      phlebo: phlebo

    };

    // const data2: any = {
    //   customer_name: customer_name,
    //   customer_age: customer_age,
    //   customer_gender: customer_gender,
    //   packages: packages,
    //   booking_date: moment(new Date()).format("YYYY-MM-DD"),
    //   //  collection_date: moment(new Date()).format("YYYY-MM-DD"),
    //   customer_email: customer_email,
    //   customer_phonenumber: customer_phonenumber,
    //   customer_altphonenumber: customer_alternatenumber,
    //   customer_whatsapppnumber: customer_whatsapppnumber,
    //   // customer_aadhar: customer_aadhar,
    //   // passport_number: passport,
    //   // coupon_applied: coupon,
    //   designation: customer_designation,
    //   // book_for: bookingFor || "",
    //   // cityid: cityId,
    //   center: centre,
    //   // is_redcash_applied: redCashCheck ? "true" : "false",
    //   // center_address: subCenterId,
    //   homecollection: false,
    //   ref_doctor: doctorId,
    //   test_type: sampleType,
    //   // "address_line2": addressLine2,
    //   // " landmark": favoritePlace,
    //   "verification_remark": verification_remark,
    //   "remarks": remarks,
    //   "rca_comment": rca_comment,
    //   "verification_status": verification_status,
    //   "booking_status": booking_status,
    //   "pickup_status": pickup_status,
    //   "phlebo_incentive": phlebo_incentive,
    //   "phlebo_convenience": phlebo_convenience,
    //   "phlebo_verification_remark": phlebo_verification_remark,
    //   phlebo: phlebo
    // };

    if (data["coupon_applied"] === 0 || couponCode === "") {
      delete data["coupon_applied"];
    }
    if (data["center_address"] === 0 || subCenterId === "") {
      delete data["center_address"];
    }
    if (data["customer_landmark"] === 0 || customer_landmark === "") {
      delete data["customer_landmark"];
    }
    if (data["verification_remark"] === 0 || verification_remark === "") {
      delete data["verification_remark"];
    }
    if (data['designation'] === null || customer_designation === null) {
      delete data['designation'];
    }

    if (data['pickup_receive_amount'] === 0 || pickup_amount === null) {
      delete data['pickup_receive_amount'];
    }

    if (data['phlebo_convenience'] === 0 || phlebo_convenience === "" || phlebo_convenience === null) {
      delete data['phlebo_convenience'];
    }

    if (data['phlebo_incentive'] === 0 || phlebo_incentive === "" || phlebo_incentive === null) {
      delete data['phlebo_incentive'];
    }

    if (data['verification_remark'] === null || verification_remark === "" || verification_remark === null) {
      delete data['verification_remark'];
    }
    if (data['remarks'] === null || remarks === "" || remarks === null) {
      delete data['remarks'];
    }
    if (data['rca_comment'] === null || rca_comment === null) {
      delete data['rca_comment'];
    }
    if (data['rm_comment'] === null || rm_comment === null) {
      delete data['rm_comment'];
    }

    if (data['phlebo_verification_remark'] === null || phlebo_verification_remark === "" || phlebo_verification_remark === null) {
      delete data['phlebo_verification_remark'];
    }

    // if (payment_source === null || payment_source === "") {
    //     delete data['payment_source'];
    // }

    // if (data['payment_mode'] === null || payment_mode === "" || payment_mode === "none") {
    //   delete data['payment_mode'];
    // }

    if (data['coupon_applied'] === 0 || couponCode === "") {
      delete data['coupon_applied'];
    }

    if (data['address_line2'] === 0 || addressLine2 === "") {
      delete data['address_line2'];
    }

    if (pickup_status === "confirmed" && payment_mode === "none") {
      alert("Payment Mode Can't be None")
    }
    if (referringDoctor === "") {
      delete data["ref_doctor"];
    }


    // await updateBooking(homechecked ? data : data2, bookingId);
    await updateBooking(data, bookingId);
    history.push(`/dashboard/gpha/booking-view/${bookingId}`);
  };
  const changeCollectionDate = (e: any) => {
    setSelectedSlot(0);
    setCollection_date(e.target.value as string);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAdharPassport((event.target as HTMLInputElement).value);
  };

  const titleSelection = (title: string) => {
    const findGender = GENDER_CHOICE.filter(
      (el: any) => el.display_name === title
    );
    setDesignation(title);
    setCustomer_designation(findGender[0].db_name);
    setCustomer_gender(findGender[0].gender);
  };

  const handleSubCenter = (val: any) => {
    setCenterId(val.center.id);
    setSubCenterId(val.id);
    setPackageDetails(val.packages)
    setCenterLatitude(val.latitude);
    setCenterLongitude(val.logitude);
    setCustomer_address(val.address);
    setCustomer_areapincode(parseInt(val.location.id));
    setCustomer_city(val.location.city);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleresetPackage = () => {
    setSubCenterId("");
    setSubCenterDetails({});
    setPackageDetails([]);
    setPackages([]);
    setPackageKey(selectedSlot);
    setSelectedSlot(0);
    setAllPackaage(true);
    setOpen(false);
    setImgTimeSlots([]);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // useEffect(() => {
  //   if (subCenterId !== "") {
  //     getMultiplePackage(
  //       `?multiple_ids=${packages}&center_address=${subCenterId}&genomics=true`
  //     );
  //   }
  // }, [packages, subCenterId]);
  useEffect(() => {
    if (subCenter) {
      setSubCenterData(subCenter);
    }
  }, [subCenter]);


  useEffect(() => {
    if (geoFencesMapMyIndia?.latitude && geoFencesMapMyIndia?.longitude) {
      setCustomerLatitude(geoFencesMapMyIndia?.latitude);
      setCustomerLongitude(geoFencesMapMyIndia?.longitude);
    }
  }, [geoFencesMapMyIndia]);

  useEffect(() => {
    if (mapmyindiaAccessToken?.accesstoken) {
      setAccessToken(mapmyindiaAccessToken?.accesstoken);
    }
  }, [mapmyindiaAccessToken]);

  useEffect(() => {
    if (subCenterId !== "") {
      getDoctorInfoById(subCenterId);
      getPackage(subCenterId, "", testType);
    }
  }, [subCenterId,testType]);

  useEffect(() => {
    if (mapAddressObject?.eLoc) {
      getPinCode(mapAddressObject?.addressTokens?.pincode);
      setCustomer_landmark(mapAddressObject?.placeAddress);
      checkGeoFenchMapMyIndia(mapAddressObject?.eLoc, "NA");
    }
  }, [mapAddressObject]);

  useEffect(() => {
    if (pin_code?.results && pin_code?.results.length > 0) {
      setCityId(pin_code?.results[0].cityid);
    }
  }, [pin_code]);

  const locationAutoCompleteSearch = (val: string) => {
    if (val.length > 2) {
      setSuggestedAddres([]);
      const urlForMap = `https://atlas.mapmyindia.com/api/places/search/json?query=${val}&access_token=${accessToken}&tokenizeAddress=true`;
      return new Promise(function (resolve, reject) {
        const id = "_" + Math.round(10000 * Math.random());
        const callbackName = "jsonp_callback_" + "data" + id;
        window[callbackName] = (data: any) => {
          delete window[callbackName];
          const ele = document.getElementById(id);
          ele?.parentNode?.removeChild(ele);
          resolve(data?.suggestedLocations);
          setSuggestedAddres(data?.suggestedLocations);
        };
        const src = urlForMap + "&callback=" + callbackName;
        const script = document.createElement("script");
        script.src = src;
        script.id = id;
        script.addEventListener("error", reject);
        (
          document.getElementsByTagName("head")[0] ||
          document.body ||
          document.documentElement
        ).appendChild(script);
      });
    }
  };
  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <div className={classes.contentHeader}>
        <h2>EDIT GENOMICS BOOKING</h2>
      </div>
      <Paper className={classes.paper} elevation={15}>
        <form onSubmit={submitForm}>
          <Grid container spacing={3} style={{ margin: "auto" }}>
            <Grid item xs={12} md={6}>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Bill To Hospital/Doctor</p>
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    value={centerName}
                    placeholder="Select Hospital/Doctor"
                    variant="outlined"
                    style={{ width: "100%", margin: "0", padding: "0" }}
                    className="input"
                    required
                  />
                  {/* <p style={{ color: "red" }}>{centerMessage}</p> */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Booking date</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <input
                    className="input"
                    name="collection_date"
                    type="date"
                    value={booking_date || ""}
                    style={{
                      width: "100%",
                      margin: "0",
                      padding: "18.5px 14px",
                    }}
                    required
                    disabled
                  />
                </Grid>
              </Grid>
              {booking?.homecollection === true ?
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <p>Sample Collection date</p>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <input
                      className="input"
                      name="collection_date"
                      type="date"
                      value={
                        (collection_date && collection_date.toString()) || ""
                      }
                      // onChange={(e) => setCollection_date(e.target.value as string)}
                      onChange={(e) => changeCollectionDate(e)}
                      style={{
                        width: "100%",
                        margin: "0",
                        padding: "18.5px 14px",
                      }}
                    // min={`${new Date().getFullYear()}-${(new Date().getMonth() + 1) < 10 ? `0${(new Date().getMonth() + 1)}` : (new Date().getMonth() + 1)}-${new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()}`}

                    />
                  </Grid>
                </Grid> : ""}
              {booking?.homecollection === true ?

                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <p>City Name</p>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      id="cityname"
                      onChange={(event, newValue) => {
                        let cName: any = "";
                        if (newValue) {
                          let obj = JSON.parse(
                            JSON.stringify(newValue, null, " ")
                          );
                          cName = obj;
                        }
                        setCityName(cName);
                      }}
                      disabled
                      options={displayCities.cities || []}
                      freeSolo
                      blurOnSelect
                      inputValue={cityName}
                      onInputChange={(event, newInputValue) => {
                        setCityName(newInputValue);
                      }}
                      aria-required
                      limitTags={1}
                      getOptionLabel={(option: any) => option}
                      getOptionDisabled={(option: any) => {
                        const cName = displayCities.cities.indexOf(
                          booking.display_name
                        );
                        console.log(cName);
                        return option === displayCities.cities[cName];
                      }}
                      disableCloseOnSelect
                      renderInput={(params) => (
                        <TextField
                          className="input"
                          {...params}
                          label="City Name"
                          variant="outlined"
                          style={{ width: "100%", margin: "0", padding: "0" }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                : ""}
              {booking?.homecollection === true ?

                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <p>Customer Address</p>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      id="colony-area-sector"
                      onChange={(event, newValue) => {
                        if (newValue) {
                          let obj = JSON.parse(
                            JSON.stringify(newValue, null, " ")
                          );
                          setMapAddressObject(obj);
                        }
                      }}
                      disabled
                      options={suggestedAddress ? suggestedAddress : []}
                      freeSolo
                      blurOnSelect
                      aria-required
                      getOptionLabel={(option: any) => `${option?.placeAddress}`}
                      filterOptions={(option: any) => option}
                      onInputChange={(event, newInputValue) => {
                        clearTimeout(timer.current);
                        timer.current = setTimeout(() => {
                          locationAutoCompleteSearch(newInputValue);
                        }, 500);
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="input"
                          {...params}
                          placeholder="Search Address"
                          variant="outlined"
                          style={{ width: "100%", margin: "0", padding: "0" }}

                        />
                      )}
                      defaultValue={{ "placeAddress": customer_landmark }}
                    />
                  </Grid>
                  {customer_latitude !== "" ? (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errorMessage}
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
                : ""}
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Test Category</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Select
                    className="input"
                    name="sample_type"
                    variant="outlined"
                    value={testType}

                    style={{ width: "100%", margin: "0" }}
                    // onChange={(e) => handleGender(e.target.value as String)}
                    onChange={(e) => setTestType(e.target.value as String)}
                  >
                    <MenuItem value="">------------</MenuItem>
                    <MenuItem value="babyscreen">Babyscreen </MenuItem>
                    <MenuItem value="cytogenetics">Cytogenetics </MenuItem>
                    <MenuItem value="genomics">Genomics </MenuItem>
                    <MenuItem value="maternal marker">Maternal Marker </MenuItem>
                    <MenuItem value="molecular diagnostics">Molecular Diagnostics </MenuItem>
                    <MenuItem value="ngs">NGS </MenuItem>

                  </Select>
                </Grid>
              </Grid>


              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Package Name</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    id="customerPackage"
                    key={packageKey}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        let packs: any = [];
                        newValue.map((val: any) => {
                          let obj = JSON.parse(JSON.stringify(val, null, " "));
                          packs.push(obj);
                        });
                        handlePackages(packs);
                      }
                    }}
                    multiple
                    disableClearable
                    options={packageList.results || []}
                    limitTags={0}
                    // disabled={
                    //   centre === "" ||
                    //   packageList.results === undefined

                    // }
                    freeSolo
                    disableCloseOnSelect
                    aria-required
                    onInputChange={(event, newInputValue) => {
                      clearTimeout(timer.current);
                      timer.current = setTimeout(() => {
                        getPackage(`center=${centre}&type=${testType}&name=${newInputValue}`);
                      }, 1000);
                    }}

                    getOptionLabel={(option: any) => {
                      return (
                        option.name +
                        "(" +
                        option.code +
                        ")" +
                        ", Rs. " +
                        option?.package_lab_prices
                        // option?.package_lab_prices?String(option?.package_lab_prices):String(option?.price)
                      );
                    }}
                    defaultValue={bookPackages}
                    getOptionDisabled={(option: any) => {
                      const packID = packageDetails.map(
                        (pack: any) => pack.id
                      );
                      return packID.includes(option.id);
                    }}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name +
                          "(" +
                          option.code +
                          ")" +
                          ", Rs. " +
                          option?.package_lab_prices +
                          "/-"}
                      </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Package"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                    disabled={booking?.pickup_status === "confirmed"||booking?.booking_status==="resampling"}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Test Type </p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Select
                    className="input"
                    name="sample_type"
                    variant="outlined"
                    value={sampleType}

                    style={{ width: "100%", margin: "0" }}
                    // onChange={(e) => handleGender(e.target.value as String)}
                    onChange={(e) => setSampleType(e.target.value as String)}
                  // required
                  >
                    <MenuItem value="prenatal">Prenatal </MenuItem>
                    <MenuItem value="postnatal">Postenatal </MenuItem>

                  </Select>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Phlebos</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  {console.log("phlebo", phlebo)}
                  <Autocomplete
                    id="booking_source"
                    onChange={(event, newValue) => {
                      if (newValue) {
                        let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                        setPhlebo(obj.id as Number || "")
                        console.log("obj.id", obj.id)
                      }
                    }}
                    inputValue={displayPhlebo || ""}
                    onInputChange={(event, newInputValue) => {
                      setDisplayPhlebo(newInputValue)
                      clearTimeout(timer.current)
                      timer.current = setTimeout(() => {
                        // getPhlebos(`&code=${newInputValue}`)
                      }, 1000)
                    }}
                    options={phleboList?.results ? [...phleboList?.results, { id: 0, user: { username: "NoPhlebo" } }] : []}
                    freeSolo
                    blurOnSelect
                    getOptionLabel={(option: any) => option?.user && option?.user?.username}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Phlebo"
                        variant="outlined"
                        style={{ width: "100%", margin: "0", padding: "0" }}
                        className="input"
                        disabled
                      />
                    )}
                  />
                </Grid>
              </Grid>

            </Grid>
            {booking?.homecollection === true ?
              <Grid item xs={12} md={6}>
                <Card
                  className="sampleCollectionTimeImaging"
                  style={{ height: "375px!important", overflow: "auto", maxHeight: 500 }}
                >
                  <p style={{ marginBottom: "1rem" }}>Sample Collection Time</p>
                  <div className={classes.slotContainer}>
                    {imgTimeSlots &&
                      imgTimeSlots?.results &&
                      imgTimeSlots?.results?.length > 0 &&
                      imgTimeSlots.results.map((slot: any) => {
                        return (
                          imgTimeSlots.results.length > 0 && (
                            <Card
                              key={slot.id}
                              className={
                                slot.id === selectedSlot
                                  ? classes.selectedSlot
                                  : classes.slot
                              }
                              onClick={() => setSelectedSlot(slot.id as Number)}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "black",
                                  fontSize: "14px",
                                }}
                              >
                                {slot.start_time} onwards
                              </p>
                              <p style={{ textAlign: "center", color: "green" }}>
                                {" "}
                                {/* Availabe slots: {slot.available_slots} */}
                              </p>
                            </Card>
                          )
                        );
                      })}
                  </div>
                </Card>
                <Grid item xs={12} md={6}>
                  <p>
                    {" "}
                    <span
                      onClick={handleClickOpen}
                      style={{ color: "#ab003c", cursor: "pointer" }}
                    >
                      click here
                    </span>{" "}
                    to View all Package
                  </p>
                </Grid>
              </Grid>
              : ""}
          </Grid>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-end"
            spacing={3}
            style={{ margin: "1rem auto", background: "#eff" }}
          >
            <Grid item xs>
              <p>Salutation</p>
              <Select
                className="input"
                name="customer_designation"
                variant="outlined"
                value={designation || ""}
                style={{ width: "100%", margin: "0" }}
                onChange={(e) => titleSelection(e.target.value as string)}
                required
              >
                <MenuItem value="Mr">Mr</MenuItem>
                <MenuItem value="Ms">Ms</MenuItem>
                <MenuItem value="Miss">Miss</MenuItem>
                <MenuItem value="Master">Master</MenuItem>
                <MenuItem value="B/O">B/O</MenuItem>
                <MenuItem value="fetus">Fetus Of</MenuItem>
                <MenuItem value="amniotic fluid">AF</MenuItem>
              </Select>
            </Grid>
            <Grid item xs>
              <p>Customer Name</p>
              <TextField
                name="customer_name"
                type="text"
                placeholder="Enter Name"
                value={customer_name}
                className="input"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: "100%", margin: "0" }}
                onChange={(e) => setCustomer_name(e.target.value as String)}
                required
              />
            </Grid>
            <Grid item xs>
              <p>Age</p>
              <TextField
                name="customer_age"
                type="number"
                placeholder="Enter Age"
                value={customer_age}
                className="input"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: "100%", margin: "0" }}
                onChange={(e) => setCustomer_age(e.target.value as String)}
                required
              />
            </Grid>
            <Grid item xs>
              <p>Gender</p>
              <Select
                className="input"
                name="customer_gender"
                variant="outlined"
                value={customer_gender || ""}
                style={{ width: "100%", margin: "0", padding: "0" }}
                onChange={(e) => setCustomer_gender(e.target.value as string)}
                required
              >
                <MenuItem selected hidden value={""}>
                  Please Select
                </MenuItem>
                <MenuItem value={"male"}>Male</MenuItem>
                <MenuItem value={"female"}>Female</MenuItem>
                <MenuItem value={"other"}>Other</MenuItem>
              </Select>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-end"
            spacing={3}
            style={{ margin: "1rem auto", background: "#eff" }}
          >
             <Grid item md={4} xs={12}>
              <p>Referring Doctor</p>
              <Autocomplete
                    key={bookingId}
                    style={{ width: "90%" }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        let obj = JSON.parse(
                          JSON.stringify(newValue, null, " ")
                        );
                        setReferringDoctor(obj.id);
                      }
                    }}
                    freeSolo
                    blurOnSelect
                    inputValue={referringDoctorName}
                    options={refDoctor.results || []}
                    onInputChange={(event, newInputValue) => {
                      setReferringDoctorName(newInputValue);
                      clearTimeout(timer.current);
                      timer.current = setTimeout(() => {
                        getRefDoctor(`&name=${newInputValue}`);
                      }, 1000);
                    }}
                    loading={loading}
                    disableCloseOnSelect
                    disableClearable
                    getOptionLabel={(option: any) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Doctor's Name"
                        variant="outlined"
                      />
                    )}
                  />
            </Grid>
            {/* <Grid item xs>
              <AddCircleIcon
                style={{ height: "auto", width: "40px" }}
                onClick={handleAddDoctor}
              />
            </Grid> */}
            {/* <Grid item md={1} xs={12}>
              {" "}
            </Grid> */}
           
            {/* <Grid item xs>
              <p>Doctor Name</p>
              <Autocomplete
                id="doctorname"
                onChange={(event, newValue) => {
                  let sourceIds: any = "";
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    sourceIds = obj?.id;
                    setDoctor_email(obj?.user?.email)
                    setDoctor_mobilenumber(obj?.user?.phonenumber)
                  }
                  setDoctorId(sourceIds);
                }}
                options={doctorInfo.results || []}
                freeSolo
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) =>
                  option?.user?.username
                }
                // onInputChange={(event, newInputValue) => {
                //   clearTimeout(timer.current);
                //   timer.current = setTimeout(() => {
                //     getDoctorInfoById(`${subCenterId}&name=${newInputValue}`);
                //   }, 1000);
                // }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    placeholder="Doctor Name"
                    variant="outlined"
                    style={{ width: "100%", margin: "0", padding: "0" }}
                    required
                  />
                )}
              // disabled={cityId === ""}
              />
            </Grid>
            <Grid item xs>
              <p>Email</p>
              <TextField
                className="input"
                name="doctor_email"
                type="email"
                placeholder="doctor@redcliffelabs.com"
                value={doctor_email}
                variant="outlined"
                style={{ margin: "0", width: "100%" }}
                onChange={(e) => setDoctor_email(e.target.value as String)}
              // required
              />
            </Grid>
            <Grid item xs>
              <p>Mobile Number</p>
              <TextField
                className="input"
                name="doctor_mobilenumber"
                type="tel"
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                value={doctor_mobilenumber || ""}
                placeholder="Doctor Mobile Number"
                variant="outlined"
                style={{ margin: "0", width: "100%" }}
                onChange={(e) =>
                  setDoctor_mobilenumber(e.target.value as String)
                }
                required
              />
            </Grid> */}
            {/* <Grid item xs>
              <p>Consanguinity</p>
              <Select
                className="input"
                name="consanguinity"
                variant="outlined"
                value={consanguinity}
                // disabled
                style={{ width: "100%", margin: "0" }}
                onChange={(e) => setConsanguinity(e.target.value as String)}
                required
              >
                <MenuItem value={"yes"}>Yes</MenuItem>
                <MenuItem value={"no"}>No</MenuItem>
              </Select>
            </Grid> */}
          </Grid>

          <Grid
            container
            spacing={3}
            direction="row"
            justify="center"
            alignItems="center"
            style={{ margin: "1rem auto" }}
          >
            <Grid item xs={12} md={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Mobile Number</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name="customer_phonenumber"
                    type="text"
                    value={customer_phonenumber}
                    placeholder="Enter Mobile Number"
                    className="input"
                    variant="outlined"
                    disabled
                    style={{ margin: "0", width: "100%" }}
                    onChange={(e) =>
                      setCustomer_phonenumber(e.target.value as String)
                    }
                    onBlur={() => verifyMobile("mobile")}
                    onFocus={() => {
                      setMobileValidation((prev: any) => ({
                        ...prev,
                        customer_phonenumber: true,
                      }));
                    }}
                    helperText={
                      !mobileValidation.customer_phonenumber &&
                      "Incorrect Phone Number"
                    }
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Alternate Mobile Number</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name="customer_alternatenumber"
                    type="text"
                    value={customer_alternatenumber}
                    placeholder="Enter Alternate Mobile Number"
                    className="input"
                    variant="outlined"
                    style={{ margin: "0", width: "100%" }}
                    onChange={(e) =>
                      setCustomer_alternatenumber(e.target.value as String)
                    }
                    required
                    onBlur={() => verifyMobile("whatsapp")}
                    onFocus={() => {
                      setMobileValidation((prev: any) => ({
                        ...prev,
                        customer_whatsapppnumber: true,
                      }));
                    }}
                    helperText={
                      !mobileValidation.customer_whatsapppnumber &&
                      "Incorrect Whatsapp Number"
                    }
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Email</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name="customer_email"
                    type="email"
                    placeholder="Enter Email"
                    value={customer_email}
                    className="input"
                    variant="outlined"
                    style={{ margin: "0", width: "100%" }}
                    onChange={(e) =>
                      setCustomer_email(e.target.value as String)
                    }
                    required
                  />
                </Grid>
              </Grid>
              {/* <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <p>Whatsapp Number</p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name="customer_whatsapppnumber"
                   type="text"
                    placeholder="Enter Whatsapp Number"
                    value={customer_whatsapppnumber}
                    className="input"
                    variant="outlined"
                    style={{ margin: "0", width: "100%" }}
                    onChange={(e) =>
                      setCustomer_whatsapppnumber(e.target.value as String)
                    }
                    onBlur={() => verifyMobile("mobile")}
                    onFocus={() => {
                      setMobileValidation((prev: any) => ({
                        ...prev,
                        customer_phonenumber: true,
                      }));
                    }}
                    helperText={
                      !mobileValidation.customer_phonenumber &&
                      "Incorrect Phone Number"
                    }
                    required
                  />
                </Grid>
              </Grid> */}
              {/* <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Aadhaar/Passport</FormLabel>
                    <RadioGroup
                      aria-label="Choose"
                      name="adharpassport"
                      value={adharPassport}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="customer_aadhar"
                        control={<Radio />}
                        label="Aadhaar Number"
                      />
                      <FormControlLabel
                        value="passport_number"
                        control={<Radio />}
                        label="Passport Number"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    className="input"
                    name="customer_aadhar"
                    type="text"
                    placeholder={
                      adharPassport === "customer_aadhar"
                        ? "Enter Adhar Number"
                        : "Enter Passport Number"
                    }
                    value={
                      adharPassport === "customer_aadhar"
                        ? customer_aadhar
                        : passport_number
                    }
                    variant="outlined"
                    style={{ margin: "0", width: "100%" }}
                    onChange={(e) =>
                      adharPassport === "customer_aadhar"
                        ? setCustomer_aadhar(e.target.value as String)
                        : setPassportNumber(e.target.value as String)
                    }
                  />
                </Grid>
              </Grid> */}
            </Grid>
            <Grid item xs={12} md={7} style={{ padding: "10px" }}>
              <div className="price-details-new-booking">
                <table style={{ width: "100%", margin: "0" }}>
                  <thead>
                    <tr>
                      <td className="cell" align="center">
                        S No.
                      </td>
                      <td className="cell" align="center">
                        Name
                      </td>
                      <td className="cell" align="center">
                        Package
                      </td>
                      <td className="cell" align="center">
                        Price
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="cell" align="center">
                        1
                      </td>
                      <td className="cell" align="left">
                        {customer_designation} {customer_name}
                      </td>
                      <td className="cell" align="left">
                        {packageDetails &&
                          packageDetails.length > 0 &&
                          packageDetails.map(
                            (packageItem: any, index: any) => {
                              return (
                                <ul>
                                  <li>
                                    {packageItem?.name}
                                    <br /> DESCRIPTION :{" "}
                                    {packageItem?.description}
                                    <br />
                                    TaT :{" "}
                                    {packageItem.tat}
                                    <br />
                                    Price :{" "}
                                    {packageItem.price ? packageItem.price : packageItem.package_lab_prices}

                                  </li>
                                </ul>
                              );
                            }
                          )}
                      </td>
                      <td className="cell" align="center">
                        ₹ {Math.floor(totalPrice)}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={4}>
                        <table style={{ width: "100%" }}>
                          <tr>
                            <td
                              className="cell"
                              align="left"
                              rowSpan={3}
                              colSpan={2}
                              style={{ width: "60%" }}
                              valign="top"
                            >
                              <Grid container spacing={1} direction="row">
                                <Grid item xs={12}>
                                  <p>Enter Coupon</p>
                                </Grid>
                                <Grid item xs={8}>
                                  <Autocomplete
                                    id="coupon"
                                    onChange={(event, newValue) => {
                                      if (newValue) {
                                        let obj = JSON.parse(
                                          JSON.stringify(newValue, null, " ")
                                        );
                                        setCoupon(obj.id as Number);
                                        setCouponCode(obj.code as string);
                                      }
                                    }}
                                    inputValue={couponCode}
                                    options={couponList?.results || []}
                                    freeSolo
                                    blurOnSelect
                                    onInputChange={(event, newInputValue) => {
                                      clearTimeout(timer.current);
                                      setCouponCode(newInputValue);
                                      timer.current = setTimeout(() => {
                                        getCoupons(
                                          `?code=${newInputValue}&org_type=imaging`
                                        );
                                      }, 1000);
                                      if (newInputValue === "") {
                                        setCoupon(0);
                                        setDiscount(0);
                                        setTncMessage("");
                                        setCouponMessage("");
                                      }
                                    }}
                                    getOptionLabel={(option: any) =>
                                      option.code
                                    }
                                    getOptionDisabled={(option: any) =>
                                      option.minimum_price > totalPrice
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        className="input"
                                        {...params}
                                        placeholder="Enter Coupon"
                                        variant="outlined"
                                        style={{
                                          width: "100%",
                                          margin: "0",
                                          padding: "0",
                                        }}
                                      />
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <Button
                                    variant="contained"
                                    fullWidth
                                    color="primary"
                                    disabled={redCashCheck}
                                    onClick={applyCoupon}
                                  >
                                    Apply
                                  </Button>
                                </Grid>
                                <p
                                  style={{
                                    color: "#8e24aa",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    alignItems: "center",
                                  }}
                                >
                                  {couponMessage} <br />
                                  {tncMessage}
                                </p>
                              </Grid>
                            </td>
                            <td
                              className="cell"
                              align="right"
                              style={{ width: "20%" }}
                            >
                              Discount
                            </td>
                            <td
                              className="cell"
                              align="center"
                              style={{ width: "20%" }}
                            >
                              ₹ {Math.floor(discount)}
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="cell"
                              align="right"
                              style={{ width: "20%" }}
                            >
                              RedCash Discount
                            </td>
                            <td
                              className="cell"
                              align="center"
                              style={{ width: "20%" }}
                            >
                              ₹ {redDisc > 0 ? Math.floor(redDisc) : 0}
                            </td>
                          </tr>

                          <tr>
                            <td className="cell" align="right">
                              <h4 className="totalPrice">Total Price</h4>
                            </td>
                            <td className="cell" align="center">
                              <h4 className="totalPrice">
                                ₹{" "}
                                {redDisc > 0
                                  ? Math.floor(totalPrice) - Math.floor(redDisc)
                                  : Math.floor(totalPrice)}
                              </h4>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            direction="row"
            justify="center"
            alignItems="center"
            style={{ margin: "10px auto" }}
          >
            <Grid item xs={12}>
              <Grid item xs={12}>
                <h3
                  style={{
                    borderTop: "dotted 1px #cccc",
                    paddingTop: "10px",
                    fontSize: "24px",
                    fontWeight: "bold",
                  }}
                >
                  Address
                </h3>
              </Grid>
              <Grid container spacing={3} style={{ margin: "1rem auto" }}>
                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>House No./Plot No./Flat No./Door No./Shop/ c/o</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="customer_address"
                      type="text"
                      value={customer_address}
                      onChange={(e) => setCustomer_address(e.target.value as string)}
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>Apartment/Building /Colony/ Block/Sector/ Street/Gali/Road/Chawl</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="customer_address"
                      type="text"
                      value={addressLine2}
                      onChange={(e) =>
                        setAddressLine2(e.target.value as string)
                      }
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>Landmark/Sublocality</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="customer_address"
                      type="text"
                      value={favoritePlace}
                      onChange={(e) => setFavoritePlace(e.target.value as string)}
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>Landmark</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="customer_landmark"
                      type="text"
                      placeholder="Enter landmark"
                      value={customer_landmark}
                      className="input"
                      variant="outlined"
                      // disabled
                      style={{ margin: "0", width: "100%" }}
                      onChange={(e) =>
                        setCustomer_landmark(e.target.value as String)
                      }
                    // required
                    />
                    <GooglePlacesAutocomplete
                      apiKey={GoogleMapsAPI}
                      selectProps={{
                        landmark,
                        onChange: setLandmark,
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>City</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="city"
                      type="text"
                      value={
                        (pin_code?.results &&
                          pin_code?.results?.length > 0 &&
                          pin_code?.results[0].city) ||
                        ""
                      }
                      disabled
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>Zone</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="areaName"
                      type="text"
                      disabled
                      value={
                        (pin_code?.results &&
                          pin_code?.results?.length > 0 &&
                          pin_code?.results[0].city) ||
                        ""
                      }
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>Pincode</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="pincode"
                      type="text"
                      disabled
                      value={
                        (booking?.customer_areapincode &&
                          booking?.customer_areapincode?.pincode) ||
                        ""
                      }
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  direction="row"
                  justify="space-around"
                  alignItems="center"
                  container
                  item
                  xs={12}
                  md={6}
                  spacing={3}
                >
                  <Grid item xs={12} md={5}>
                    <p>Verification Remark</p>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      name="verification_remark"
                      placeholder="Enter Remark"
                      type="text"
                      value={verification_remark}
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                      onChange={(e) => setVerification_remark(e.target.value as string)}
                      // required
                      disabled={booking?.verification_status !== "pending"}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Verification Status</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <Select
                      className="input"
                      name="verification_status"
                      variant="outlined"
                      value={verification_status || "pending"}
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      onChange={(e) => setVerification_status(e.target.value as string)}
                      // required
                      disabled={booking?.verification_status !== "pending"}
                    >
                      {/* <MenuItem value={"pending"}>Pending</MenuItem> */}
                      <MenuItem value={"confirmed"}>Confirmed</MenuItem>
                      {/* <MenuItem value={"cancelled"}>Cancelled</MenuItem> */}
                    </Select>
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Booking Status</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <Select
                      className="input"
                      name="verification_status"
                      variant="outlined"
                      value={booking_status || "pending"}
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      onChange={(e) =>
                        setBooking_status(e.target.value as string)
                      }
                    // disabled={booking.booking_status === "rescheduled" || booking.booking_status === "resampling"} ////manisha 28-01-2022

                    >
                      <MenuItem disabled value={booking_status}>
                        {booking_status}
                      </MenuItem>

                    </Select>
                  </Grid>
                </Grid>

                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Pickup Status</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <Select
                      className="input"
                      name="verification_status"
                      variant="outlined"
                      value={pickup_status || "pending"}
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      onChange={(e) => setPickup_status(e.target.value as string)}
                      disabled={checkAdditionalPickupStatus !== undefined || !phlebo}
                      required
                    >

                      <MenuItem value={"pending"}>Pending</MenuItem>
                      <MenuItem value={"confirmed"}>Confirmed</MenuItem>
                      <MenuItem value={"cancelled"}>Cancelled</MenuItem>
                      <MenuItem value={"hold"}>Hold</MenuItem>
                    </Select>

                    {checkAdditionalPickupStatus !== undefined ? <p style={{ color: "#ab003c" }}>You Can't Change Pickup Status until Additional Member Status is pending</p> : ""}
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Pickup Date</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <input
                      className="input"
                      name="collection_date"
                      type="date"
                      value={pickup_date || ""}
                      style={{ width: "100%", margin: "0", padding: "18.5px 14px" }}
                      onChange={(e) => setPickup_date(e.target.value)}
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Pickup Time</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <input
                      className="input"
                      name="collection_date"
                      type="time"
                      value={pickup_time || ""}
                      style={{ width: "100%", margin: "0", padding: "18.5px 14px" }}
                      onChange={(e) => setPickup_time(e.target.value)}
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Pickup Amount</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <TextField
                      name="pickup_amount"
                      placeholder="Pickup Amount"
                      type="number"
                      value={pickup_amount}
                      className="input"
                      variant="outlined"
                      disabled
                      style={{ margin: "0", width: "100%" }}
                      required={pickup_status === "confirmed"}
                    // onChange={(e) => setPickup_amount(e.target.value as any)}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Payment Mode</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <Select
                      className="input"
                      name="payment_mode"
                      variant="outlined"
                      value={payment_mode || ""}
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      disabled={pickup_status !== "confirmed"}
                      onChange={(e: any) => hanbdlePaymentMode(e)}
                      required={pickup_status === "confirmed"}
                    >

                      <MenuItem disabled value={"none"}>None</MenuItem>
                      <MenuItem disabled value={booking?.payment_mode}>{booking?.payment_mode}</MenuItem>
                      <MenuItem value={"cash"}>Cash</MenuItem>
                      <MenuItem value={"online"}>Online Payment</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
                {/* <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                      <Grid item xs={12} style={{ padding: "0" }}>
                          <p>Payment Source</p>
                      </Grid>
                      <Grid item xs={12} style={{ padding: "0" }}>
                          <TextField
                              name="payment_source"
                              placeholder="Payment source"
                              type="text"
                              value={payment_source}
                              className="input"
                              variant="outlined"
                              style={{ margin: "0", width: "100%" }}
                              onChange={(e) => setPayment_source(e.target.value as string)}
                              required={pickup_status === "confirmed"}
                          />
                      </Grid>
                  </Grid> */}
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Phlebo Incentive</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <TextField
                      name="phlebo_verification_remark"
                      placeholder="Enter phlebo Incentive"
                      type="number"
                      value={phlebo_incentive}
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                      onChange={(e) => setPhlebo_incentive(e.target.value as string)}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Phlebo Convenience</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <TextField
                      name="phlebo_verification_remark"
                      placeholder="Enter phlebo Convenience"
                      type="number"
                      value={phlebo_convenience}
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                      onChange={(e) => setPhlebo_convenience(e.target.value as string)}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Phlebo Verification Remarks</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <Select
                      className="input"
                      name="phlebo_verification_remarks"
                      variant="outlined"
                      value={phlebo_verification_remark || ""}
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      onChange={(e) => setPhlebo_verification_remark(e.target.value as string)}
                    >
                      <MenuItem value={phlebo_verification_remark}>{phlebo_verification_remark}</MenuItem>
                      <MenuItem value={"Customer out of station"}>Customer Out Of Station</MenuItem>
                      <MenuItem value={"Booking not confirm so customer not ready"}>Booking not Confirm so Customer not ready</MenuItem>
                      <MenuItem value={"Customer not in fasting"}>Customer not in fasting</MenuItem>
                      <MenuItem value={"Phlebo late"}>Phlebo late</MenuItem>
                      <MenuItem value={"Hold Due To Payment"}>Hold Due To Payment</MenuItem>
                      <MenuItem value={"Customer wants to reschedule but not sure"}>Customer Wants to reschedule but not sure</MenuItem>
                      <MenuItem value={"Customer wants to cancel"}>Customer Wants to Cancel</MenuItem>
                      <MenuItem value={"Address not found"}>Address not Found</MenuItem>
                      <MenuItem value={"Customer not responding to call"}>Customer not responding to call</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "1rem 0", width: "100%", padding: "1rem" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Route Manager Comments</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <Select
                      className="input"
                      name="routeManager"
                      variant="outlined"
                      value={rm_comment}
                      defaultValue={booking?.rm_comment}
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      onChange={(e) => setRMComment(e.target.value as number)}
                    >

                      {RM_COMMENTS.map((item: any) => {
                        return (
                          <MenuItem key={item.id} value={`${item.id}`}>{item.name}</MenuItem>
                        )
                      })}
                    </Select>
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "1rem 0", width: "100%", padding: "1rem" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>RCA Comments</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <Select
                      className="input"
                      name="rca_comment"
                      variant="outlined"
                      value={rca_comment}
                      defaultValue={booking?.rca_comment}
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      onChange={(e) => setRCAComment(e.target.value as number)}
                    >
                      {RCA_COMMENT?.map((item: any) => {
                        return (
                          <MenuItem key={item.id} value={`${item?.id}`}>{item.name}</MenuItem>
                        )
                      })}
                    </Select>
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={3} spacing={3} style={{ margin: "10px 0", width: "100%", padding: "10px" }}>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <p>Remark</p>
                  </Grid>
                  <Grid item xs={12} style={{ padding: "0" }}>
                    <TextField
                      name="remark"
                      placeholder="Enter Remark"
                      type="text"
                      value={remarks}
                      className="input"
                      variant="outlined"
                      style={{ margin: "0", width: "100%" }}
                      onChange={(e) => setRemarks(e.target.value as string)}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className={classes.buttonContainer}>
            <Button
              color="primary"
              type="submit"
              variant="contained"
              disabled={loading || !selectedSlot || packages.length === 0}
            >
              Update booking
            </Button>
          </div>
        </form>
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {" "}
          Do You Want To Change Package
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ color: "#ab003c" }}
          >
            For Changing Package You have to select center and time slot as well{" "}
            <br />
            Our center and Time Slot is mapped according to Package
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleresetPackage} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Dialog
        open={openDocModal}
        onClose={() => setOpenDocModal(false)}
        fullWidth
        maxWidth="lg"
      >
        <AddDoctor
          getRefDoctor={getRefDoctor}
          setOpenDocModal={setOpenDocModal}
        />
      </Dialog> */}
    </main>
  );
};
const mapStateToProps = (state: any) => ({
  pin_code: state.GenomicsPhaReducer.pin_code,
  packageList: state.GenomicsPhaReducer.packageList,
  couponList: state.GenomicsPhaReducer.couponList,
  booking: state.GenomicsPhaReducer.booking,
  booking_slots: state.GenomicsPhaReducer.booking_slots,
  loading: state.GenomicsPhaReducer.loading,
  cities: state.GenomicsPhaReducer.cities,
  subCenter: state.GenomicsPhaReducer.subCenter,
  imagingTimeSlots: state.GenomicsPhaReducer.imagingTimeSlots,
  // multiplePackage: state.GenomicsPhaReducer.multiplePackage,
  displayCities: state.GenomicsPhaReducer.displayCities,
  checkGeoFenceStatus: state.GenomicsPhaReducer.checkGeoFenceStatus,
  geoFencesMapMyIndia: state.GenomicsPhaReducer.geoFencesMapMyIndia,
  mapmyindiaAccessToken: state.GenomicsPhaReducer.mapmyindiaAccessToken,
  doctorInfo: state.GenomicsPhaReducer.doctorInfo,
  phleboList: state.GenomicsPhaReducer.phleboList,
  centerInfo: state.GenomicsPhaReducer.centerInfo,
  refDoctor: state.GenomicsPhaReducer.refDoctor,
});

export default connect(mapStateToProps, {
  getPackage,
  updateBooking,
  getCoupons,
  getBookingById,
  getAvailableSlots,
  getCities,
  getSubCenterInfo,
  getPinCode,
  getImagingTimeslots,
  // getMultiplePackage,
  getDisplayCities,
  checkGeoFenceArea,
  checkGeoFenchMapMyIndia,
  getMapMyIndiaAccessToken,
  getDoctorInfoById,
  getCenterInfo,
  getPhlebos,
  getRefDoctor,

})(EditBookingForm);